<template>
  <span>登出成功</span>
</template>

<script>
  export default {
    name: 'notification-template'
  }
</script>
